import { useState, useEffect } from 'react';

/**
 * Custom hook to track if this is the user's first visit to the website
 * Uses localStorage to persist the visit state across sessions
 * 
 * @returns {Object} { isFirstVisit: boolean, markVisited: function }
 */
function useFirstVisit() {
  const [isFirstVisit, setIsFirstVisit] = useState(false);

  useEffect(() => {
    // Check if user has visited before
    const hasVisited = localStorage.getItem('nightfall_has_visited');
    
    if (!hasVisited) {
      // First time visiting
      setIsFirstVisit(true);
    }
  }, []);

  /**
   * Mark that the user has visited
   * This will set the flag in localStorage so future visits won't be "first"
   */
  const markVisited = () => {
    localStorage.setItem('nightfall_has_visited', 'true');
    setIsFirstVisit(false);
  };

  return { isFirstVisit, markVisited };
}

export default useFirstVisit;

